import {animate, state, style, transition, trigger} from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
  state(
    'show',
    style({
      opacity: 1,
    }),
  ),
  state(
    'hide',
    style({
      opacity: 0,
    }),
  ),
  transition('show => hide', [animate('600ms cubic-bezier(0.25, 0.1, 0.25, 1)')]),
  transition('hide => show', [animate('600ms cubic-bezier(0.25, 0.1, 0.25, 1)')]),
]);

export const slideIn = trigger('slideIn', [
  state(
    'prev',
    style({
      transform: 'translateY(-10px)',
    }),
  ),
  state(
    'current',
    style({
      transform: 'none',
    }),
  ),
  state(
    'next',
    style({
      transform: 'translateY(10px)',
    }),
  ),
  transition('prev => current', [animate('600ms cubic-bezier(0.25, 0.1, 0.25, 1)')]),
  transition('current => next', [animate('600ms cubic-bezier(0.25, 0.1, 0.25, 1)')]),
]);
